import { Superficie_vivienda } from './../../../models/superficie_vivienda.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;

@Component({
    selector: 'app-superficie-vivienda',
    templateUrl: './superficie-vivienda.component.html',
    styleUrls: ['./superficie-vivienda.component.css'],
    providers: [FormService]
})
export class SuperficieViviendaComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public superficie_vivienda: Superficie_vivienda;
    public form;
    public idForm;

    public form115;

    public form131;
    public form132;
    public form133;

    public num;
    public num2;

    public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.idForm = localStorage.getItem("form");
        console.log(this.idForm);


        if (this.idForm == "1-3.1") {
            this.form131 = true;
        }
        if (this.idForm == "1-3.2") {
            this.form132 = true;
        }
        if (this.idForm == "1-3.3") {
            this.form133 = true;
            this.num = '6.2 SUPERFICIE QUE SE REGULARIZA (En caso que se requiera regularizar vivienda existente en la modificación)'
            this.num2 = '6.3 Superficie Proyecto De Radicacion Modificado'
        }
        if (this.idForm == "1-1.5") {
            this.form115 = true;
            this.num = '6.2 SUPERFICIE QUE SE REGULARIZA (En caso que se requiera regularizar vivienda existente)'
            this.num2 = '6.3 Superficies'
        }




        this.form = new FormGroup({
          

            /* permiso otorgado */
            total: new FormControl(''),

            totalSobre: new FormControl(''),
            vivienda1Sobre: new FormControl(''),
            vivienda2Sobre: new FormControl(''),
            vivienda3Sobre: new FormControl(''),

            totalTotal: new FormControl(''),
            vivienda1Total: new FormControl(''),
            vivienda2Total: new FormControl(''),
            vivienda3Total: new FormControl(''),

            totalOcupacion: new FormControl(''),
            vivienda1Ocupacion: new FormControl(''),
            vivienda2Ocupacion: new FormControl(''),
            vivienda3Ocupacion: new FormControl(''),

            superficieIncluida: new FormControl(''),
            superficieTotal: new FormControl(''),
            maximoLotes: new FormControl(''),

            /* permiso modificado */
            total_Mod: new FormControl(''),

            totalSobre_Mod: new FormControl(''),
            vivienda1Sobre_Mod: new FormControl(''),
            vivienda2Sobre_Mod: new FormControl(''),
            vivienda3Sobre_Mod: new FormControl(''),

            totalTotal_Mod: new FormControl(''),
            vivienda1Total_Mod: new FormControl(''),
            vivienda2Total_Mod: new FormControl(''),
            vivienda3Total_Mod: new FormControl(''),

            totalOcupacion_Mod: new FormControl(''),
            vivienda1Ocupacion_Mod: new FormControl(''),
            vivienda2Ocupacion_Mod: new FormControl(''),
            vivienda3Ocupacion_Mod: new FormControl(''),

            superficieIncluida_Mod: new FormControl(''),
            superficieTotal_Mod: new FormControl(''),
            maximoLotes_Mod: new FormControl(''),


            N1vivienda1Sobre: new FormControl(''),
            N1vivienda2Sobre: new FormControl(''),
            N1vivienda3Sobre: new FormControl(''),

            N2vivienda1Sobre: new FormControl(''),
            N2vivienda2Sobre: new FormControl(''),
            N2vivienda3Sobre: new FormControl(''),

            N3vivienda1Sobre: new FormControl(''),
            N3vivienda2Sobre: new FormControl(''),
            N3vivienda3Sobre: new FormControl(''),

            mansardavivienda1Sobre: new FormControl(''),
            mansardavivienda2Sobre: new FormControl(''),
            mansardavivienda3Sobre: new FormControl(''),

        })

        if (!JSON.parse(localStorage.getItem("superficie_vivienda"))) {
            localStorage.setItem("superficie_vivienda", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("superficie_vivienda"));

    

            /* permiso otorgado */
            this.form.controls['total'].setValue(this.rows[0] ? this.rows[0].total : '')
            this.form.controls['totalSobre'].setValue(this.rows[0] ? this.rows[0].totalSobre : '')
            this.form.controls['vivienda1Sobre'].setValue(this.rows[0] ? this.rows[0].vivienda1Sobre : '')
            this.form.controls['vivienda2Sobre'].setValue(this.rows[0] ? this.rows[0].vivienda2Sobre : '')
            this.form.controls['vivienda3Sobre'].setValue(this.rows[0] ? this.rows[0].vivienda3Sobre : '')

            this.form.controls['totalTotal'].setValue(this.rows[0] ? this.rows[0].totalTotal : '')
            this.form.controls['vivienda1Total'].setValue(this.rows[0] ? this.rows[0].vivienda1Total : '')
            this.form.controls['vivienda2Total'].setValue(this.rows[0] ? this.rows[0].vivienda2Total : '')
            this.form.controls['vivienda3Total'].setValue(this.rows[0] ? this.rows[0].vivienda3Total : '')

            this.form.controls['totalOcupacion'].setValue(this.rows[0] ? this.rows[0].totalOcupacion : '')
            this.form.controls['vivienda1Ocupacion'].setValue(this.rows[0] ? this.rows[0].vivienda1Ocupacion : '')
            this.form.controls['vivienda2Ocupacion'].setValue(this.rows[0] ? this.rows[0].vivienda2Ocupacion : '')
            this.form.controls['vivienda3Ocupacion'].setValue(this.rows[0] ? this.rows[0].vivienda3Ocupacion : '')

            this.form.controls['superficieIncluida'].setValue(this.rows[0] ? this.rows[0].superficieIncluida : '')
            this.form.controls['superficieTotal'].setValue(this.rows[0] ? this.rows[0].superficieTotal : '')
            this.form.controls['maximoLotes'].setValue(this.rows[0] ? this.rows[0].maximoLotes : '')
            this.form.controls['vivienda3Ocupacion'].setValue(this.rows[0] ? this.rows[0].vivienda3Ocupacion : '')

            /* permiso modificado */
            this.form.controls['total_Mod'].setValue(this.rows[0] ? this.rows[0].total_Mod : '')
            this.form.controls['totalSobre_Mod'].setValue(this.rows[0] ? this.rows[0].totalSobre_Mod : '')
            this.form.controls['vivienda1Sobre_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda1Sobre_Mod : '')
            this.form.controls['vivienda2Sobre_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda2Sobre_Mod : '')
            this.form.controls['vivienda3Sobre_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda3Sobre_Mod : '')

            this.form.controls['totalTotal_Mod'].setValue(this.rows[0] ? this.rows[0].totalTotal_Mod : '')
            this.form.controls['vivienda1Total_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda1Total_Mod : '')
            this.form.controls['vivienda2Total_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda2Total_Mod : '')
            this.form.controls['vivienda3Total_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda3Total_Mod : '')

            this.form.controls['totalOcupacion_Mod'].setValue(this.rows[0] ? this.rows[0].totalOcupacion_Mod : '')
            this.form.controls['vivienda1Ocupacion_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda1Ocupacion_Mod : '')
            this.form.controls['vivienda2Ocupacion_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda2Ocupacion_Mod : '')
            this.form.controls['vivienda3Ocupacion_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda3Ocupacion_Mod : '')

            this.form.controls['superficieIncluida_Mod'].setValue(this.rows[0] ? this.rows[0].superficieIncluida_Mod : '')
            this.form.controls['superficieTotal_Mod'].setValue(this.rows[0] ? this.rows[0].superficieTotal_Mod : '')
            this.form.controls['maximoLotes_Mod'].setValue(this.rows[0] ? this.rows[0].maximoLotes_Mod : '')
            this.form.controls['vivienda3Ocupacion_Mod'].setValue(this.rows[0] ? this.rows[0].vivienda3Ocupacion_Mod : '')


            this.form.controls['N1vivienda1Sobre'].setValue(this.rows[0] ? this.rows[0].N1vivienda1Sobre : '')
            this.form.controls['N1vivienda2Sobre'].setValue(this.rows[0] ? this.rows[0].N1vivienda2Sobre : '')
            this.form.controls['N1vivienda3Sobre'].setValue(this.rows[0] ? this.rows[0].N1vivienda3Sobre : '')

            this.form.controls['N2vivienda1Sobre'].setValue(this.rows[0] ? this.rows[0].N2vivienda1Sobre : '')
            this.form.controls['N2vivienda2Sobre'].setValue(this.rows[0] ? this.rows[0].N2vivienda2Sobre : '')
            this.form.controls['N2vivienda3Sobre'].setValue(this.rows[0] ? this.rows[0].N2vivienda3Sobre : '')

            this.form.controls['N3vivienda1Sobre'].setValue(this.rows[0] ? this.rows[0].N3vivienda1Sobre : '')
            this.form.controls['N3vivienda2Sobre'].setValue(this.rows[0] ? this.rows[0].N3vivienda2Sobre : '')
            this.form.controls['N3vivienda3Sobre'].setValue(this.rows[0] ? this.rows[0].N3vivienda3Sobre : '')

            this.form.controls['mansardavivienda1Sobre'].setValue(this.rows[0] ? this.rows[0].N3vivienda1Sobre : '')
            this.form.controls['mansardavivienda2Sobre'].setValue(this.rows[0] ? this.rows[0].N3vivienda2Sobre : '')
            this.form.controls['mansardavivienda3Sobre'].setValue(this.rows[0] ? this.rows[0].N3vivienda3Sobre : '')
        }

        this.superficie_vivienda = {
          

            /* permiso otorgado */
            total: '',

            totalSobre: '',
            vivienda1Sobre: '',
            vivienda2Sobre: '',
            vivienda3Sobre: '',

            totalTotal: '',
            vivienda1Total: '',
            vivienda2Total: '',
            vivienda3Total: '',

            totalOcupacion: '',
            vivienda1Ocupacion: '',
            vivienda2Ocupacion: '',
            vivienda3Ocupacion: '',

            superficieIncluida: '',
            superficieTotal: '',
            maximoLotes: '',

            /* permiso modificado */
            total_Mod: '',

            totalSobre_Mod: '',
            vivienda1Sobre_Mod: '',
            vivienda2Sobre_Mod: '',
            vivienda3Sobre_Mod: '',

            totalTotal_Mod: '',
            vivienda1Total_Mod: '',
            vivienda2Total_Mod: '',
            vivienda3Total_Mod: '',

            totalOcupacion_Mod: '',
            vivienda1Ocupacion_Mod: '',
            vivienda2Ocupacion_Mod: '',
            vivienda3Ocupacion_Mod: '',

            superficieIncluida_Mod: '',
            superficieTotal_Mod: '',
            maximoLotes_Mod: '',


            N1vivienda1Sobre: '',
            N1vivienda2Sobre: '',
            N1vivienda3Sobre: '',

            N2vivienda1Sobre: '',
            N2vivienda2Sobre: '',
            N2vivienda3Sobre: '',

            N3vivienda1Sobre: '',
            N3vivienda2Sobre: '',
            N3vivienda3Sobre: '',

            mansardavivienda1Sobre: '',
            mansardavivienda2Sobre: '',
            mansardavivienda3Sobre: '',

        };


    }

    add_superficie_vivienda() {
        localStorage.setItem("superficie_vivienda", JSON.stringify([]));
        this.actualRow = localStorage.getItem("superficie_vivienda");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          

            /* permiso otorgado */
            total: this.form.value.total,

            totalSobre: this.form.value.totalSobre,
            vivienda1Sobre: this.form.value.vivienda1Sobre,
            vivienda2Sobre: this.form.value.vivienda2Sobre,
            vivienda3Sobre: this.form.value.vivienda3Sobre,

            totalTotal: this.form.value.totalTotal,
            vivienda1Total: this.form.value.vivienda1Total,
            vivienda2Total: this.form.value.vivienda2Total,
            vivienda3Total: this.form.value.vivienda3Total,

            totalOcupacion: this.form.value.totalOcupacion,
            vivienda1Ocupacion: this.form.value.vivienda1Ocupacion,
            vivienda2Ocupacion: this.form.value.vivienda2Ocupacion,
            vivienda3Ocupacion: this.form.value.vivienda3Ocupacion,

            superficieIncluida: this.form.value.superficieIncluida,
            superficieTotal: this.form.value.superficieTotal,
            maximoLotes: this.form.value.maximoLotes,

            /* permiso modificado */
            total_Mod: this.form.value.total_Mod,

            totalSobre_Mod: this.form.value.totalSobre_Mod,
            vivienda1Sobre_Mod: this.form.value.vivienda1Sobre_Mod,
            vivienda2Sobre_Mod: this.form.value.vivienda2Sobre_Mod,
            vivienda3Sobre_Mod: this.form.value.vivienda3Sobre_Mod,

            totalTotal_Mod: this.form.value.totalTotal_Mod,
            vivienda1Total_Mod: this.form.value.vivienda1Total_Mod,
            vivienda2Total_Mod: this.form.value.vivienda2Total_Mod,
            vivienda3Total_Mod: this.form.value.vivienda3Total_Mod,

            totalOcupacion_Mod: this.form.value.totalOcupacion_Mod,
            vivienda1Ocupacion_Mod: this.form.value.vivienda1Ocupacion_Mod,
            vivienda2Ocupacion_Mod: this.form.value.vivienda2Ocupacion_Mod,
            vivienda3Ocupacion_Mod: this.form.value.vivienda3Ocupacion_Mod,

            superficieIncluida_Mod: this.form.value.superficieIncluida_Mod,
            superficieTotal_Mod: this.form.value.superficieTotal_Mod,
            maximoLotes_Mod: this.form.value.maximoLotes_Mod,


            N1vivienda1Sobre: this.form.value.N1vivienda1Sobre,
            N1vivienda2Sobre: this.form.value.N1vivienda2Sobre,
            N1vivienda3Sobre: this.form.value.N1vivienda3Sobre,

            N2vivienda1Sobre: this.form.value.N2vivienda1Sobre,
            N2vivienda2Sobre: this.form.value.N2vivienda2Sobre,
            N2vivienda3Sobre: this.form.value.N2vivienda3Sobre,

            N3vivienda1Sobre: this.form.value.N3vivienda1Sobre,
            N3vivienda2Sobre: this.form.value.N3vivienda2Sobre,
            N3vivienda3Sobre: this.form.value.N3vivienda3Sobre,

            mansardavivienda1Sobre: this.form.value.mansardavivienda1Sobre,
            mansardavivienda2Sobre: this.form.value.mansardavivienda2Sobre,
            mansardavivienda3Sobre: this.form.value.mansardavivienda3Sobre,
        })
        localStorage.setItem("superficie_vivienda", JSON.stringify(this.rows));


    }
    delete_superficie_vivienda(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("superficie_vivienda", JSON.stringify(this.rows));
            }
        }
    }


}
